// <s-footer-accordion>: footer columns are <details> accordions on mobile. From md (768px) up they are
// forced open and their summaries stop toggling, so desktop shows six plain columns.
class FooterAccordion extends HTMLElement {
  #controller = null;
  #query = window.matchMedia('(min-width: 768px)');

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#sync();
    this.#query.addEventListener('change', () => this.#sync(), { signal });
    this.addEventListener('click', (event) => {
      if (this.#query.matches && event.target.closest('summary')) event.preventDefault();
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #sync() {
    for (const details of this.querySelectorAll('details[data-footer-col]')) {
      details.open = this.#query.matches;
      const summary = details.querySelector('summary');
      if (summary) summary.tabIndex = this.#query.matches ? -1 : 0;
    }
  }
}

if (!customElements.get('s-footer-accordion')) customElements.define('s-footer-accordion', FooterAccordion);
